import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOtp]'
})
export class OtpDirective {

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const sanitizedValue = value.replace(/[^0-9]/g, '');

   
    if (this.el.nativeElement.value !== sanitizedValue) {
      this.el.nativeElement.value = sanitizedValue;
      this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
